<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
    }
  },
  mounted() {
    Vue.nextTick(() => {
      setTimeout(() => {
        this.openModal()
      }, 3000);
    });
  },
  methods: {
    openModal() {
      $("#modal-authentication-required").modal("show");
    },
  },
  computed: {

  }
};
</script>

<template>
  <div id="modal-authentication-required" class="modal fade" tabindex="-1" role="dialog" modal-authentication-required-component>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body py-0 px-1">
          <button class="close modal-close-icon" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="d-flex flex-column justify-content-center align-items-center text-center py-5 px-3">
            <h3>{{ft("globals.register.join_now")}}</h3>
            <p>{{ft("globals.register.join_now_desc")}}</p>
            <a role="button" href="/users/sign_up" class="btn btn-primary mx-2 mb-2">{{ft("globals.login.sign_up")}}</a>
            <p>{{ft('globals.login.sign_in').html_safe}}</p>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[modal-authentication-required-component] {
  .modal {
    &-dialog {
      overflow: hidden;
      transition: transform 0.3s ease-out, max-width 0.25s, height 0.25s !important;
    }

    &-body {

      & > .container {
        overflow-y: auto;
      }

      .close-icon {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  .modal-elements{
    text-align: center;

    .image {
      max-width: 16rem;
    }
  }

}
</style>